/**
 * @file bookingStepper.component.tsx
 * @path apps/website/src/features/booking/components/layout/bookingStepper.component.tsx
 * @description Horizontal progress bar showing booking wizard progress.
 */

import { cn } from "@sirbastians/utils";

interface BookingStepperProps {
  steps: { id: string; name: string }[];
  activeStepId: string;
}

export const BookingStepper = ({ steps, activeStepId }: BookingStepperProps) => {
  const activeIdx = steps.findIndex((s) => s.id === activeStepId);

  return (
    <div
      className="flex w-full items-center gap-1.5 mb-6"
      aria-label="Booking Progress"
      role="progressbar"
      aria-valuenow={activeIdx + 1}
      aria-valuemin={1}
      aria-valuemax={steps.length}
    >
      {steps.map((step, idx) => (
        <div
          key={step.id}
          className={cn(
            "h-1.5 flex-1 rounded-full transition-colors duration-500 ease-in-out",
            idx <= activeIdx ? "bg-accent" : "bg-border",
          )}
          title={`Step ${idx + 1}: ${step.name}`}
        />
      ))}
    </div>
  );
};